// export this package's api
import Cascader from './Cascader';
export default Cascader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-cascader/es/index.js
// module id = 1390
// module chunks = 0